import React from "react";
import { Form } from "semantic-ui-react";
import { useExtLabels } from './extLabels'

const Candidate = ({ title, model, errors = {}, onChange, disabled, withSize = true }) => {
    const l = useExtLabels()

    const handleChange = (name, value) => {
        onChange({ ...model, [name]: value });
    }

    return (
        <React.Fragment>
            <Form.Input
                disabled={disabled}
                label={title}
                name="name"
                value={model.name}
                onChange={({ target }) => handleChange(target.name, target.value)}
                required
                error={!!errors.name}
            />
            {model.company !== undefined && (
                <Form.Input
                    disabled={disabled}
                    label={l("Nazwa firmy")}
                    name="company"
                    value={model.company}
                    onChange={({ target }) => handleChange(target.name, target.value)}
                    required
                    error={!!errors.company}
                />
            )}
            <Form.Input
                disabled={disabled}
                label={l("Adres url")}
                name="url"
                value={model.url}
                onChange={({ target }) => handleChange(target.name, target.value)}
                required
                error={!!errors.url}
            />
            { withSize && <Form.Group inline required>
                <label>
                    {l('Wielkość')} <span style={{ color: "red" }}>*</span>
                </label>
                <Form.Radio
                    disabled={disabled}
                    label={l("Mały podmiot")}
                    name="orgSize"
                    value="mały"
                    checked={model.orgSize === "mały"}
                    onChange={( e, { name, value } ) => handleChange(name, value)}
                    error={!!errors.orgSize}
                />
                <Form.Radio
                    disabled={disabled}
                    label={l("Średni / duży podmiot")}
                    name="orgSize"
                    value="średni-duży"
                    checked={model.orgSize === "średni-duży"}
                    onChange={( e, { name, value } ) => handleChange(name, value)}
                    error={!!errors.orgSize}
                /> 
            </Form.Group> }
            <Form.Group inline required>
                <label>
                    {l('Członek e-Izby')} <span style={{ color: "red" }}>*</span>
                </label>
                <Form.Radio
                    disabled={disabled}
                    label={l("Tak")}
                    name="member"
                    value="tak"
                    checked={model.member === "tak"}
                    onChange={( e, { name, value } ) => handleChange(name, value)}
                    error={!!errors.member}
                />
                <Form.Radio
                    disabled={disabled}
                    label={l("Nie")}
                    name="member"
                    value="nie"
                    checked={model.member === "nie"}
                    onChange={( e, { name, value } ) => handleChange(name, value)}
                    error={!!errors.member}
                />
            </Form.Group>
        </React.Fragment>
    );
};

export default Candidate;